export const heroStats = [
  { label: '整理入口', value: '128+', icon: 'ri-links-line' },
  { label: '话题标签', value: '46', icon: 'ri-price-tag-3-line' },
  { label: '使用教程', value: '18 篇', icon: 'ri-book-open-line' },
  { label: '反馈响应', value: '24 小时内', icon: 'ri-customer-service-2-line' },
];

export const searchHints = ['黑料导航怎么用', '使用教程', '常见问题', '反馈说明', '标签筛选'];

export const quickSteps = [
  {
    id: 'step-1',
    no: '01',
    title: '打开首页先搜索',
    desc:
      '进入黑料导航后，先在上方输入框输入关键词，例如「黑料导航怎么用」，系统会优先列出对应的教程与入口说明，避免盲目翻找。',
    points: ['关键词模糊匹配', '回车直达结果区', '输入即提示热门词'],
    icon: 'ri-search-eye-line',
  },
  {
    id: 'step-2',
    no: '02',
    title: '用标签定位方向',
    desc:
      '话题标签墙把内容按方向归好类，点选一个或多个标签即可组合筛选。标签支持叠加，选得越多范围越准，找到目标入口通常只需两步。',
    points: ['标签可多选组合', '选中有高亮反馈', '一键清空重置'],
    icon: 'ri-price-tag-3-line',
  },
  {
    id: 'step-3',
    no: '03',
    title: '收藏并查看教程',
    desc:
      '常用的入口可以加入收藏夹，下次直接打开。遇到打不开、找不到入口等情况，翻到「常见问题」或对应使用教程，对照步骤自查即可。',
    points: ['收藏夹本地保存', '教程对照自查', '问题可提交反馈'],
    icon: 'ri-bookmark-3-line',
  },
];

export const tagGroups = [
  { name: '新手相关', tags: ['新手指引', '黑料导航怎么用', '快速上手', '第一次使用', '使用教程'] },
  { name: '功能相关', tags: ['标签筛选', '收藏夹', '快捷入口', '搜索技巧', '移动端适配', '入口整理'] },
  { name: '帮助相关', tags: ['帮助中心', '常见问题', '反馈说明', '问题自查', '打不开怎么办', '找不到入口'] },
  { name: '说明相关', tags: ['更新日志', '安全提示', '免责声明', '使用规范', '浏览建议'] },
];

export const tutorials = [
  {
    id: 'tut-1',
    title: '黑料导航怎么用：3 分钟上手完整流程',
    category: '新手指引',
    readTime: '3 分钟',
    views: '2.4 万',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20dark%20desk%20scene%20with%20tablet%20and%20sticky%20notes%2C%20warm%20amber%20accent%20lighting%2C%20clean%20flat%20editorial%20illustration%2C%20charcoal%20background%2C%20no%20text&width=800&height=560&seq=heili-tut-01&orientation=landscape',
  },
  {
    id: 'tut-2',
    title: '黑料导航使用教程：标签筛选与组合技巧',
    category: '功能技巧',
    readTime: '4 分钟',
    views: '1.8 万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20floating%20label%20chips%20and%20filter%20panels%2C%20warm%20amber%20and%20green%20accents%20on%20charcoal%2C%20clean%20flat%20editorial%20illustration%2C%20no%20text&width=800&height=560&seq=heili-tut-02&orientation=landscape',
  },
  {
    id: 'tut-3',
    title: '如何收藏常用入口并快速直达',
    category: '功能技巧',
    readTime: '3 分钟',
    views: '1.2 万',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20bookmark%20and%20star%20icons%20floating%20over%20warm%20amber%20gradient%20panel%2C%20clean%20flat%20editorial%20illustration%2C%20charcoal%20accents%2C%20no%20text&width=800&height=560&seq=heili-tut-03&orientation=landscape',
  },
  {
    id: 'tut-4',
    title: '常见问题自查：打不开或找不到入口怎么办',
    category: '问题排查',
    readTime: '5 分钟',
    views: '2.1 万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20warning%20and%20checklist%20cards%20on%20warm%20charcoal%20background%2C%20amber%20highlight%2C%20clean%20flat%20editorial%20illustration%2C%20no%20text&width=800&height=560&seq=heili-tut-04&orientation=landscape',
  },
  {
    id: 'tut-5',
    title: '移动端使用教程：手机上的操作要点',
    category: '设备适配',
    readTime: '4 分钟',
    views: '9600',
    cover:
      'https://readdy.ai/api/search-image?query=smartphone%20mockup%20with%20floating%20ui%20cards%2C%20warm%20amber%20and%20green%20tones%20on%20dark%20charcoal%2C%20clean%20flat%20editorial%20illustration%2C%20no%20text&width=800&height=560&seq=heili-tut-05&orientation=landscape',
  },
  {
    id: 'tut-6',
    title: '反馈与帮助：遇到问题如何提交说明',
    category: '反馈说明',
    readTime: '3 分钟',
    views: '8800',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20chat%20bubbles%20and%20message%20icons%2C%20warm%20amber%20highlights%20on%20charcoal%20background%2C%20clean%20flat%20editorial%20illustration%2C%20no%20text&width=800&height=560&seq=heili-tut-06&orientation=landscape',
  },
];

export const newsDigest = [
  { date: '09-11', tag: '教程', text: '新增《黑料导航怎么用》图文步骤，覆盖搜索与标签两条主线。' },
  { date: '09-09', tag: '帮助', text: '常见问题补充「打不开怎么办」自查清单，可对照逐条排查。' },
  { date: '09-06', tag: '功能', text: '标签墙支持多选组合，选得越多筛选范围越准。' },
  { date: '09-03', tag: '反馈', text: '反馈说明页整理提交必填项，写清楚更容易被处理。' },
  { date: '08-30', tag: '适配', text: '移动端操作要点更新，手机浏览更顺手。' },
  { date: '08-27', tag: '规范', text: '使用规范与安全提示同步刷新，请注意浏览建议。' },
];

export const faqs = [
  {
    q: '黑料导航怎么用？第一次来要做什么？',
    a: '第一次使用建议按「搜索 → 标签 → 收藏」的顺序：先输入关键词，再点选话题标签缩小范围，找到常用入口后加入收藏夹，下次即可快速直达。完整步骤可查看《黑料导航怎么用》使用教程。',
  },
  {
    q: '黑料导航使用教程在哪里看？',
    a: '在本页「使用教程」区域可以看到按主题整理的教程卡片，包含新手指引、标签筛选、移动端操作与问题排查等方向，按需点开对照操作即可。',
  },
  {
    q: '黑料导航常见问题有哪些？',
    a: '常见问题集中在入口打不开、找不到目标入口、标签筛选不生效、收藏丢失以及移动端显示异常等。你可以在本页「常见问题」区域逐条展开查看说明。',
  },
  {
    q: '找不到想要的入口怎么办？',
    a: '先确认关键词是否准确，再尝试用话题标签组合筛选；若仍然找不到，可到「反馈说明」区域提交你搜索的关键词与预期方向，帮助中心会据此补充说明。',
  },
  {
    q: '遇到问题可以反馈吗？怎么反馈更有效？',
    a: '可以。反馈时建议写清楚使用的设备、操作步骤、搜索关键词与期望结果，重复问题可附上截图。信息越完整，定位与处理越快。',
  },
  {
    q: '页面打不开或加载很慢怎么处理？',
    a: '可先刷新页面、切换网络或更换浏览器再试。若仍无法打开，请对照「问题排查」教程逐项自查，并通过反馈通道说明具体现象。',
  },
];

export const comments = [
  {
    id: 'c1',
    name: '风里来的人',
    initial: '风',
    tone: 'primary',
    time: '2 小时前',
    likes: 128,
    text: '照《黑料导航怎么用》那篇走了一遍，标签多选真的省事，几步就定位到想要的入口了。',
  },
  {
    id: 'c2',
    name: '夜航船',
    initial: '夜',
    tone: 'accent',
    time: '5 小时前',
    likes: 96,
    text: '之前一直找不到目标入口，看了常见问题才发现是关键词写太长，改成短词立马出结果。',
  },
  {
    id: 'c3',
    name: '半糖不加冰',
    initial: '半',
    tone: 'secondary',
    time: '昨天',
    likes: 74,
    text: '移动端的使用教程很实用，手机上滑和点的位置都讲清楚了，不用再猜。',
  },
  {
    id: 'c4',
    name: '旧巷的猫',
    initial: '旧',
    tone: 'primary',
    time: '2 天前',
    likes: 61,
    text: '反馈通道挺快的，我提交了搜索关键词的问题，第二天就看到帮助中心补充了说明。',
  },
];